export default {
  production: true,
  apiUrl: 'https://sf-legacy-api.now.sh',
};
